<template>
    <v-dialog v-model="show" width="560px">
        <template v-slot:activator="{ on, attrs }">
            <v-icon ref="bottom-popup-button" v-on="on" v-bind="attrs" small color="warning darken-1">mdi-star-circle-outline</v-icon>
        </template>
        <v-card tile class="bottom-popup-card">
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <div class="bottom-popup-card__img">
                            <img src="/images/sub/member/starbucks.svg" alt="starbucks">
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <p class="text-16 text-md-14 color-gray-7e text-center">
                            회원가입시 전문가 DB에 연락처, 이메일 공개를 체크하시는 전문가에게 스타벅스 쿠폰을 증정합니다. <br class="d-none d-md-block"/>(회원가입 완료후 2일이내 쿠폰발송)
                        </p>
                    </v-col>
                    <!-- <v-col cols="12">
                        <v-col>
                            <v-stepper alt-labels class="bottom-popup-stepper row justify-center align-center elevation-0">
                                <v-stepper-step v-for="(step, i) in steps" :key="i" :step="i + 1" :complete-icon="`mdi-numeric-${i + 1}`" complete color="secondary" style="white-space:pre-line;">
                                    {{ step }}
                                </v-stepper-step>
                            </v-stepper>
                        </v-col>
                    </v-col> -->
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
const steps = ["로그인", "전문가 검색", "상세보기", "수정하기", "연락처 이메일\n공개 체크", "보유기술정보\n입력 (옵션)"];

export default {
    props: ["value"],
    computed: {
        outOfSync() {
            return this.value !== this.show;
        },
    },
    data() {
        return {
            show: this.value || false,
            steps,
        };
    },
    methods: {
        init() {
            if (this.outOfSync) this.show = this.value;
        },
        sync() {
            if (this.outOfSync) this.$emit("input", this.show);
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        show() {
            this.sync();
        },
        value() {
            this.init();
        },
    },
};
</script>

<style lang="scss">
.bottom-popup-card {
    padding: 40px;
    &__img{
        max-width: 200px;
        margin:auto;
    }
    .v-card__text{
        padding: 0 !important;
    }
}
.bottom-popup-stepper {
    border: 1px solid #e6e6e6;

    .v-stepper__step {
        flex-basis: 33.3333% !important;
    }
    .v-stepper__label{
        display: block !important;
        text-align: center !important;
    }
}
@media(max-width:768px){
    .bottom-popup-stepper {
        .v-stepper__step {
            padding: 10px;
        }
    }
}
@media(max-width:768px){
    .bottom-popup-card {
        padding: 20px 15px;
    }
    .bottom-popup-stepper {
        .v-stepper__step {
            flex-basis: 50% !important;
        }
    }
}
</style>
